import React, { memo, useMemo } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const IndustryCard = memo(({ industry }) => {
  const { t } = useTranslation();
  const k = industry.i18nKey;
  const title = t(`industries.${k}.title`);
  const descriptions = useMemo(
    () => [t(`industries.${k}.d0`), t(`industries.${k}.d1`)],
    [t, k]
  );

  return (
    <Link
      to={industry.url}
      className="vh-service-card"
      aria-label={`${title}: ${descriptions.join(", ")}`}
    >
      <span className="vh-service-card__glow" aria-hidden="true" />
      <div className="vh-service-card__inner">
        <div className="vh-service-card__icon-wrap">
          <div className="vh-service-card__icon">
            <img
              decoding="async"
              loading="lazy"
              src={industry.icon.src}
              alt={t(`industries.${k}.alt`)}
              className="vh-service-card__icon-img"
            />
          </div>
        </div>
        <div className="vh-service-card__body">
          <h3 className="vh-service-card__title title-h4">{title}</h3>
          <ul className="vh-service-card__list">
            {descriptions.map((desc, i) => (
              <li key={`${industry.id}-${i}`} className="vh-service-card__li">
                {desc}
              </li>
            ))}
          </ul>
          <span className="vh-service-card__cta">
            {t("serviceCard.viewService")}
          </span>
        </div>
      </div>
    </Link>
  );
});

IndustryCard.displayName = "IndustryCard";

export default IndustryCard;
